module.exports = __webpack_public_path__ + "img/cocotaps.2c4a22da.png";